import { render, staticRenderFns } from "./ManagementSpaRootView.vue?vue&type=template&id=e7220548"
import script from "./ManagementSpaRootView.vue?vue&type=script&lang=js"
export * from "./ManagementSpaRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports